// =========================================================================
// 돈만농(mandoora) Service API 카탈로그 — API 테스터(ApiTester.vue)용
//   실제 게임 API(service_api_v1, Koa) 엔드포인트 기준.
//   호출: POST {BaseURL}{endpoint}  ·  Body = JSON(대문자 파라미터)
//   인증: 헤더 access_token + 바디 USER_ID(테스터가 로그인 유저로 자동 주입) + 공통헤더(package/device_*)
//   응답 봉투: { result, result_info, res_data }  (result === 1 성공)
//   Base URL: 돈만농 게임서버 (미정 — 테스터에서 직접 입력)
//   ※ auth:true 엔드포인트는 USER_ID 를 테스터가 자동 주입하므로 defaults 에 넣지 않는다.
// =========================================================================

export const SERVICE_API_MANDOORA_CATALOG = [
  {
    group: 'Auth (로그인)',
    apis: [
      { name: 'sa_auth_login', label: '로그인', endpoint: '/auth/login', auth: false,
        defaults: { LOGIN_TYPE: 'guest', AUTH_ID: 'TEST_DEVICE_0001', AD_ID: '', IDFV_ID: '' } },
    ],
  },
  {
    group: 'UserInfo (유저정보)',
    apis: [
      { name: 'sa_get_user_info',         label: '유저 정보 조회',   endpoint: '/userinfo/get_user_info',         auth: false, defaults: {} },
      { name: 'sa_get_friends_list',      label: '친구 목록',        endpoint: '/userinfo/get_friends_list',      auth: true, defaults: {} },
      { name: 'sa_check_phone_verify',    label: '폰인증 상태확인',  endpoint: '/userinfo/check_user_phone_verify', auth: true, defaults: {} },
      { name: 'sa_create_phone_code',     label: '폰인증 코드발급',  endpoint: '/userinfo/create_phone_verify_code', auth: true, defaults: {} },
      { name: 'sa_regist_nick',           label: '닉네임 등록',      endpoint: '/userinfo/regist_nick',           auth: true, defaults: { USER_NICK: '테스트닉' } },
      { name: 'sa_set_sexage',            label: '성별/나이 저장',   endpoint: '/userinfo/set_userinfo_sexage',   auth: true, defaults: { SEX: 'M', AGE: 20 },
        hints: [{ key: 'SEX', values: ['M', 'F'], desc: 'M=남 / F=여' }] },
      { name: 'sa_delete_account',        label: '계정 탈퇴',        endpoint: '/userinfo/delete_user_account',   auth: true, defaults: {} },
    ],
  },
  {
    group: 'UserData (유저데이터)',
    apis: [
      { name: 'sa_load_data',         label: '데이터 로드',      endpoint: '/userdata/load_data',              auth: true, defaults: {} },
      { name: 'sa_save_data',         label: '데이터 저장',      endpoint: '/userdata/save_data',              auth: true, defaults: { DATA_VERSION: 1, USER_DATA: {} } },
      { name: 'sa_review_state',      label: '리뷰 상태',        endpoint: '/userdata/load_data_review_state', auth: true, defaults: {} },
      { name: 'sa_save_push_data',    label: '푸시설정 저장',    endpoint: '/userdata/save_push_data',         auth: true, defaults: { PUSH_STATE: 'Y' } },
      { name: 'sa_save_push_token',   label: '푸시토큰 저장',    endpoint: '/userdata/save_push_token',        auth: true, defaults: { PUSH_TOKEN: 'TEST_TOKEN' } },
    ],
  },
  {
    group: 'Mail (우편)',
    apis: [
      { name: 'sa_mail_load', label: '우편함 조회', endpoint: '/mail/mail_load', auth: true, defaults: {} },
    ],
  },
  {
    group: 'Shop (쿠폰상점)',
    apis: [
      { name: 'sa_shop_list',        label: '상품 목록',    endpoint: '/shop/shop_product_list',         auth: true, defaults: { PLACEMENT_CODE: '' } },
      { name: 'sa_shop_buying',      label: '상품 구매/발행', endpoint: '/shop/shop_product_buying',       auth: true, defaults: { PRODUCT_CODE: '' } },
      { name: 'sa_shop_get_state',   label: '주문 상태조회', endpoint: '/shop/shop_product_get_state',    auth: true, defaults: { ORDER_ID: '' } },
      { name: 'sa_shop_state_change', label: '구매상태 변경', endpoint: '/shop/shop_product_state_change', auth: true, defaults: { PID: 0, STATE: '' } },
    ],
  },
  {
    group: 'PF · Gem (젬 지급)',
    apis: [
      { name: 'sa_add_gem',            label: '젬 지급(태그)',   endpoint: '/mandoora/add_gem',                 auth: true, defaults: { EVENT_TAG: 'TEST' } },
      { name: 'sa_add_gem_rv',         label: '젬-광고',        endpoint: '/mandoora/add_gem_rv',              auth: true, defaults: {} },
      { name: 'sa_add_gem_attendance', label: '젬-출석',        endpoint: '/mandoora/add_gem_attendance',      auth: true, defaults: { INDEX: 1 } },
      { name: 'sa_add_gem_luckybox',   label: '젬-럭키박스',    endpoint: '/mandoora/add_gem_luckybox',        auth: true, defaults: {} },
      { name: 'sa_add_gem_festival',   label: '젬-D7페스티벌',  endpoint: '/mandoora/add_gem_festival_d7',     auth: true, defaults: { INDEX: 1 } },
      { name: 'sa_add_gem_profile',    label: '젬-프로필이벤트', endpoint: '/mandoora/add_gem_profile_event',   auth: true, defaults: {} },
      { name: 'sa_add_gem_mission',    label: '젬-데일리미션',  endpoint: '/mandoora/add_gem_daily_mission',   auth: true, defaults: { MISSION_KEY: 'm1' } },
      { name: 'sa_add_gem_quest',      label: '젬-퀘스트',      endpoint: '/mandoora/add_gem_quest_reward',    auth: true, defaults: { QUEST_KEY: 'q1' } },
      { name: 'sa_add_gem_goldenbell', label: '젬-골든벨',      endpoint: '/mandoora/add_gem_goldenbell_reward', auth: true, defaults: { PID: 0 } },
      { name: 'sa_add_gem_youtube',    label: '젬-유튜브',      endpoint: '/mandoora/add_gem_youtube_reward',  auth: true, defaults: { PID: '', REWARD_INDEX: 1 } },
    ],
  },
  {
    group: 'PF · Claim (보상수령)',
    apis: [
      { name: 'sa_claim_stamp_cycle', label: '스탬프 사이클',   endpoint: '/mandoora/claim_stamp_cycle_reward',   auth: true, defaults: { PID: 0, STATE_INDEX: 1 } },
      { name: 'sa_claim_snapplay',    label: '스냅플레이 데일리', endpoint: '/mandoora/claim_snapplay_daily_reward', auth: true, defaults: { PID: 0 } },
      { name: 'sa_claim_wannab',      label: '워너비 27일',     endpoint: '/mandoora/claim_wannab_reward',        auth: true, defaults: { DAY_INDEX: 1 } },
    ],
  },
  {
    group: 'PF · Shop (포인트상점)',
    apis: [
      { name: 'sa_pf_buy_cash',         label: '코인→현금 환전', endpoint: '/mandoora/buy_shop_cash',         auth: true, defaults: { PID: 0, USER_NAME: '', BANK_NAME: '', BANK_ACCOUNT: '', PHONE: '', KO_NATIONAL_ID: '' } },
    ],
  },
  {
    group: 'PF · Coupon (쿠폰)',
    apis: [
      { name: 'sa_pf_coupon_check', label: '쿠폰 확인', endpoint: '/mandoora/coupon_check', auth: true, defaults: { COUPON_ID: '' } },
      { name: 'sa_pf_coupon_use',   label: '쿠폰 사용', endpoint: '/mandoora/coupon_use',   auth: true, defaults: { COUPON_ID: '' } },
    ],
  },
  {
    group: 'PF · Friend / Cash (친구·수거)',
    apis: [
      { name: 'sa_regist_friend_ai',   label: 'AI친구 등록',    endpoint: '/mandoora/regist_friend_ai',      auth: true, defaults: { EVENT_TAG: '' } },
      { name: 'sa_add_ai_friend',      label: 'AI친구(레거시)',  endpoint: '/mandoora/add_ai_friend',         auth: true, defaults: {} },
      { name: 'sa_pf_regist_referee',  label: '추천인 등록',    endpoint: '/mandoora/regist_referee_id',     auth: true, defaults: { REFEREE_ID: '' } },
      { name: 'sa_friend_delete',      label: '친구 삭제',      endpoint: '/mandoora/friend_delete',         auth: true, defaults: { REFEREE_ID: '' } },
      { name: 'sa_gather_cash',        label: '내 포인트 수집',  endpoint: '/mandoora/gather_cash',           auth: true, defaults: {} },
      { name: 'sa_gather_friends',     label: '친구 캐시수집',   endpoint: '/mandoora/gather_cash_friends',   auth: true, defaults: { FRIENDS: [] } },
      { name: 'sa_gather_friends_ai',  label: 'AI친구 캐시수집', endpoint: '/mandoora/gather_cash_friends_ai', auth: true, defaults: { FRIENDS: [] } },
      { name: 'sa_gather_friends_all', label: '전체 캐시수집',   endpoint: '/mandoora/gather_cash_friends_all', auth: true, defaults: {} },
    ],
  },
  {
    group: 'PF · Quiz (OX퀴즈)',
    apis: [
      { name: 'sa_ox_quiz_info',        label: 'OX 퀴즈 정보', endpoint: '/mandoora/ox_quiz_info',        auth: false, defaults: {} },
      { name: 'sa_ox_quiz_participate', label: 'OX 퀴즈 참여', endpoint: '/mandoora/ox_quiz_participate', auth: true,  defaults: { PID: 0 } },
    ],
  },
  {
    // 멀티페치는 별도 그룹으로 분리 — 여기서 따로 관리(지원 FETCH_KEY 추가/설명 등)
    group: 'PF · 멀티페치 (multiple_fetch_data)',
    apis: [
      { name: 'sa_multiple_fetch', label: '멀티페치 (multiple_fetch_data)', endpoint: '/mandoora/multiple_fetch_data', auth: true,
        // 기본값은 자주 쓰는 소수만 — 나머지는 아래 표에서 클릭해 추가/제거
        defaults: { FETCH_KEYS: ['CashInfo', 'GemInfo', 'PlayerAbilityInfo'] },
        hints: [{ key: 'FETCH_KEYS',
          // 게임서버 service_api_v1/.../routes/mandoora/multiple_fetch_data.js 의 지원 키 전체 (서버 처리 순서와 동일)
          // keys 가 있으면 테스터에서 표(체크박스)로 렌더 — 행 클릭 시 FETCH_KEYS 에 추가/제거
          keys: [
            { k: 'CashInfo',             d: '유저 캐시(코인/골드) 정보' },
            { k: 'GemInfo',              d: '보유 젬 + 오늘 획득 젬' },
            { k: 'CashLog',              d: '캐시 증감 로그(적립/차감 각 최근 200건)' },
            { k: 'GemLog',               d: '젬 획득/사용 로그' },
            { k: 'FriendsInfo',          d: '친구 목록/정보' },
            { k: 'UserMailList',         d: '유저 우편함 목록' },
            { k: 'BuyProductList',       d: '내 상품 구매내역(쿠폰 발행 주문 포함)' },
            { k: 'GoldCashProductList',  d: '구입 가능한 코인/현금 리스트' },
            { k: 'UserBuyProductLogs',   d: '전체 유저 구매 프로덕트 로그' },
            { k: 'OxQuiz_EventInfo',     d: 'OX퀴즈 이벤트 정보' },
            { k: 'Youtube_EventInfo',    d: '유튜브 이벤트 목록 정보' },
            { k: 'Youtube_RewardInfo',   d: '유튜브 이벤트 보상 정보' },
            { k: 'PlayerAbilityInfo',    d: '플레이어 능력치(강화) 집계 — 직원+기계' },
            { k: 'AbilityLog',           d: '최근 factor 획득 로그 100건(직원+기계)' },
            { k: 'PlayerMaximumLev',     d: '플레이어 최대 레벨' },
            { k: 'RefereeInfo',          d: '추천인(레퍼럴) 정보' },
            { k: 'Event_Newbie_D7Info',  d: '신규 7일차 이벤트 정보' },
            { k: 'GemLog_RecentInfo',    d: '최근 젬 로그(럭키박스)' },
            { k: 'RankList',             d: '랭킹 목록' },
            { k: 'GoldMarketPrice',      d: '금 시세(마켓 가격)' },
            { k: 'TutoState',            d: '튜토리얼 진행 상태(없으면 생성)' },
            { k: 'BoosterQuestsInfo',    d: '부스터 퀘스트 목록 + 진행도' },
            { k: 'DailyMissionInfo',     d: '일일 미션 목록 + 진행도' },
            { k: 'Event_Noti',           d: '활성 이벤트 공지' },
            { k: 'StampCycleInfo',       d: '통합 스탬프 활성 사이클(MAF/TYR/ADJO)' },
            { k: 'WannaB_Info',          d: 'WannaB 이벤트 정보' },
            { k: 'CookieCharInfo',       d: '금펫(쿠키캐릭) 오늘 뽑기 현황 + 활성 펫' },
            { k: 'SnapplayDailyInfo',    d: '스냅플레이 일일 챌린지 현황(진행/보상)' },
            { k: 'TargetProductInfo',    d: '유저 목표상품키' },
            { k: 'CollectionConfig',     d: '컬렉션(도감) 설정 정보' },
          ] }] },
    ],
  },
  {
    group: 'PF · Misc (기타/데이터)',
    apis: [
      { name: 'sa_mail_read',      label: '메일 읽음',  endpoint: '/mandoora/mail_read',           auth: true,  defaults: { READ_MAILS: [] } },
      { name: 'sa_tuto_success',   label: '튜토 완료',  endpoint: '/mandoora/tuto_success',        auth: true,  defaults: { TUTO_KEY: '' } },
      { name: 'sa_machine_lev_up', label: '기계 레벨업', endpoint: '/mandoora/machine_lev_up',       auth: true,  defaults: { MACHINE_TYPE: 'MACHINE_1', COUNT: 1, DURATION_SEC: 0, FETCH_KEYS: ['PlayerAbilityInfo'] },
        hints: [
          { key: 'MACHINE_TYPE', values: ['MACHINE_1', 'MACHINE_2', 'MACHINE_3'], desc: '기계 종류 (config.MACHINE.PER 키)' },
          { key: 'COUNT', desc: '올릴 레벨 수(대수). GEM = PRICE×COUNT 차감' },
          { key: 'DURATION_SEC', desc: '유효기간(초). 0/미입력이면 config 기본(약 30일)' },
        ] },
      { name: 'sa_public_rank',    label: '랭킹 TOP10', endpoint: '/mandoora/public_rank',         auth: false, defaults: {} },
      { name: 'sa_save_client_log', label: '클라 로그저장', endpoint: '/mandoora/save_client_log',  auth: false, defaults: { LOG_TEXT: 'test log', ID_TYPE: 'USER_ID' } },
    ],
  },
  {
    group: 'PF · 뽑기 / 목표 (신규)',
    apis: [
      // 쿠키캐릭터 뽑기 — 일일 카운트 기반, 별도 파라미터 없음(USER_ID 자동)
      { name: 'sa_pf_add_cookie_pet',   label: '쿠키캐릭터 뽑기',   endpoint: '/mandoora/add_cookie_pet',   auth: true, defaults: { FETCH_KEYS: ['CookieCharInfo'] } },
      // 직원 뽑기 — MODE: NORMAL(일반모집) | PREMIUM(고급모집), COUNT: 뽑기 횟수(1~100)
      { name: 'sa_pf_add_employee',     label: '직원 뽑기(일반/고급)', endpoint: '/mandoora/add_employee',  auth: true, defaults: { MODE: 'NORMAL', COUNT: 1, DURATION_SEC: 0, FETCH_KEYS: ['PlayerAbilityInfo'] },
        hints: [
          { key: 'MODE', values: ['NORMAL', 'PREMIUM'], desc: 'NORMAL=일반모집 / PREMIUM=고급모집' },
          { key: 'COUNT', desc: '뽑기 횟수 (1~100)' },
        ] },
      // 상품교환 목표 설정 — PRODUCT_KEY(목표상품키, 최대 64자) → PUBLIC_USER_DATA.TARGET_PRODUCT
      { name: 'sa_pf_set_goal_product', label: '상품교환 목표 설정', endpoint: '/mandoora/set_goal_product', auth: true, defaults: { PRODUCT_KEY: '', FETCH_KEYS: ['TargetProductInfo'] } },
    ],
  },
];
